export default function getScopedClassName(componentName: string) {
  return (className: string) => `${componentName}--${className}`;
}
